/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Meta_TitleInputs */

const en_svc_n8n_meta_title = /** @type {(inputs: Svc_N8n_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n Automation Agency — n8n AI Workflow Development | Lindevo`)
};

const lv_svc_n8n_meta_title = /** @type {(inputs: Svc_N8n_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n automatizācija — n8n darba plūsmu izstrāde ar AI | Lindevo`)
};

/**
* | output |
* | --- |
* | "n8n Automation Agency — n8n AI Workflow Development \| Lindevo" |
*
* @param {Svc_N8n_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_meta_title = /** @type {((inputs?: Svc_N8n_Meta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Meta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_meta_title(inputs)
	return en_svc_n8n_meta_title(inputs)
});